import { render } from "./CustomButton.vue?vue&type=template&id=0cc22640&scoped=true"
import script from "./CustomButton.vue?vue&type=script&lang=js"
export * from "./CustomButton.vue?vue&type=script&lang=js"

import "./CustomButton.vue?vue&type=style&index=0&id=0cc22640&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-0cc22640"

export default script